import React from 'react';
export function About() {
  return <section className="bg-rise-white text-rise-black py-14 md:py-[120px] px-6 overflow-hidden" data-id="element-9">
      <div className="max-w-rise-content mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-10">
        <div className="order-2 md:order-1" data-id="element-11">
          <h2 className="font-playfair text-[32px] md:text-[38px] mb-8" data-id="element-12">
            Cine sunt eu
          </h2>

          <div className="font-dm-sans text-[19px] text-rise-gray space-y-6 mb-10 leading-relaxed" data-id="element-13">
            <p data-id="element-14">
              Sunt <strong data-id="element-15">Teodora Trifu</strong>, Consilier pentru Dezvoltare
              Personală, cu 9 ani experiență în lucrul cu tineri și metode
              creative bazate pe arte combinate. De 5 ani sunt implicată activ
              în sprijinirea dezvoltării emoționale a tinerilor prin ONG-ul pe
              care l-am construit.
            </p>
            <p data-id="element-16">
              Am văzut același tipar de zeci de ori: oameni inteligenți,
              sensibili și capabili care rămân blocați nu pentru că nu pot, ci
              pentru că nu au structură, claritate și un mediu care să îi
              susțină fără judecată.
            </p>
            <p data-id="element-17">
              De aceea am creat <strong data-id="element-18">R.I.S.E.</strong>: un cadru simplu și
              clar care te ajută să treci de la confuzie și autosabotaj la
              identitate, stabilitate și progres real.
            </p>
          </div>

          <div className="w-full flex justify-center" data-id="element-19">
            <a href="https://comunitatearise.ro/despremine" target="_blank" rel="noopener noreferrer" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-3 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors inline-flex items-center justify-center" data-id="element-20">
              Află mai multe detalii despre mine!
            </a>
          </div>
        </div>

        <div className="order-1 md:order-2 relative max-w-md mx-auto w-full" data-id="element-21">
          {/* Large diamond / rhombus frame — top right */}
          <svg className="absolute -top-14 -right-14 w-48 h-48 text-rise-gold pointer-events-none" viewBox="0 0 150 150" fill="none" stroke="currentColor" strokeWidth="0.7" data-id="element-22">
            <rect x="75" y="5" width="95" height="95" rx="4" transform="rotate(45 75 52)" data-id="element-23" />
            <rect x="75" y="15" width="72" height="72" rx="3" transform="rotate(45 75 52)" strokeDasharray="3 5" data-id="element-24" />
          </svg>

          {/* Starburst / radial lines — top left */}
          <svg className="absolute -top-10 -left-10 w-32 h-32 text-rise-gold/50 pointer-events-none" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-25">
            <line x1="50" y1="50" x2="50" y2="5" data-id="element-26" />
            <line x1="50" y1="50" x2="82" y2="12" data-id="element-27" />
            <line x1="50" y1="50" x2="95" y2="50" data-id="element-28" />
            <line x1="50" y1="50" x2="82" y2="88" data-id="element-29" />
            <line x1="50" y1="50" x2="50" y2="95" data-id="element-30" />
            <line x1="50" y1="50" x2="18" y2="88" data-id="element-31" />
            <line x1="50" y1="50" x2="5" y2="50" data-id="element-32" />
            <line x1="50" y1="50" x2="18" y2="12" data-id="element-33" />
            <circle cx="50" cy="50" r="8" strokeWidth="0.6" data-id="element-34" />
            <circle cx="50" cy="50" r="2.5" fill="currentColor" data-id="element-35" />
          </svg>

          {/* Horizontal thin lines — bottom left */}
          <svg className="absolute -bottom-8 -left-16 w-44 h-20 text-rise-gold/30 pointer-events-none" viewBox="0 0 160 60" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-36">
            <line x1="0" y1="10" x2="160" y2="10" data-id="element-37" />
            <line x1="20" y1="22" x2="140" y2="22" data-id="element-38" />
            <line x1="40" y1="34" x2="120" y2="34" data-id="element-39" />
            <line x1="55" y1="46" x2="105" y2="46" data-id="element-40" />
          </svg>

          {/* Organic curve — bottom right */}
          <svg className="absolute -bottom-16 -right-12 w-52 h-52 text-rise-gold/40 pointer-events-none" viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="0.6" data-id="element-41">
            <path d="M20 180 Q 60 100 120 120 T 180 40" strokeDasharray="4 4" data-id="element-42" />
            <path d="M30 190 Q 70 120 130 135 T 190 50" strokeDasharray="1 6" data-id="element-43" />
          </svg>

          {/* Small cross accents */}
          <svg className="absolute top-8 -right-7 w-5 h-5 text-rise-gold pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-44">
            <line x1="10" y1="2" x2="10" y2="18" data-id="element-45" />
            <line x1="2" y1="10" x2="18" y2="10" data-id="element-46" />
          </svg>
          <svg className="absolute bottom-12 -left-6 w-4 h-4 text-rise-gold/70 pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-47">
            <line x1="10" y1="2" x2="10" y2="18" data-id="element-48" />
            <line x1="2" y1="10" x2="18" y2="10" data-id="element-49" />
          </svg>

          {/* Scattered gold dots */}
          <div className="absolute -top-4 left-16 w-3 h-3 rounded-full bg-rise-gold pointer-events-none" data-id="element-50"></div>
          <div className="absolute top-20 -right-5 w-2 h-2 rounded-full bg-rise-gold/50 pointer-events-none" data-id="element-51"></div>
          <div className="absolute -bottom-3 right-24 w-2.5 h-2.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-52"></div>
          <div className="absolute bottom-32 -left-3 w-2 h-2 rounded-full bg-rise-gold/60 pointer-events-none" data-id="element-53"></div>
          <div className="absolute top-1/2 -right-8 w-1.5 h-1.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-54"></div>

          {/* Double offset borders */}
          <div className="absolute inset-0 border border-rise-gold/60 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-55"></div>
          <div className="absolute inset-0 border border-rise-gold/25 rounded-xl -translate-x-3 -translate-y-3 pointer-events-none" data-id="element-56"></div>

          <img src="https://cdn.magicpatterns.com/uploads/1ntVDLPDdbCkpniASyVzNv/Teodora_3.jpg" alt="Teodora Trifu" className="w-full h-auto md:h-[600px] object-cover object-top rounded-xl shadow-xl z-10 relative" data-id="element-57" />
        </div>
      </div>
    </section>;
}